class DLPageSwiperPopH extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.swiperContainer = null;
    this.prevBtn = null;
    this.nextBtn = null;
    this.currentEl = null;
    this.totalEl = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // 获取所有必要的 DOM 元素
    this.swiperContainer = this.querySelector('.dl-page-swiper-pop-h-swiper');
    this.prevBtn = this.querySelector('.dl-page-swiper-pop-h-swiper-controls-prev');
    this.nextBtn = this.querySelector('.dl-page-swiper-pop-h-swiper-controls-next');
    this.currentEl = this.querySelector('.dl-page-swiper-pop-h-swiper-controls-pagination-current');
    this.totalEl = this.querySelector('.dl-page-swiper-pop-h-swiper-controls-pagination-total');

    if (!this.swiperContainer) {
      console.warn('Swiper container not found');
      return;
    }

    // 初始化 Swiper
    this.initSwiper();

    // 绑定控制按钮事件
    this.bindEvents();

    // 绑定弹窗按钮事件
    this.bindPopButtons();

    // 统一所有 slide 的高度
    this.unifySlideHeights();

    // 监听窗口大小变化
    this.bindResizeEvent();
  }

  initSwiper() {
    // 等待 Swiper 库加载完成
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not loaded');
      return;
    }

    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      speed: 600,
      effect: 'slide',
      allowTouchMove: true,
      on: {
        slideChange: () => {
          this.updatePagination();
          this.updateButtonsState();
        },
        init: () => {
          this.updatePagination();
          this.updateButtonsState();
        }
      }
    });
  }

  bindEvents() {
    // 上一张按钮
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        if (this.swiper && !this.prevBtn.classList.contains('dl-disabled')) {
          this.swiper.slidePrev();
        }
      });
    }

    // 下一张按钮
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        if (this.swiper && !this.nextBtn.classList.contains('dl-disabled')) {
          this.swiper.slideNext();
        }
      });
    }
  }

  bindPopButtons() {
    // 获取所有弹窗按钮
    const popButtons = this.querySelectorAll('.dl-page-swiper-pop-h-item-pop-btn-btn');

    popButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // 找到按钮所在的 slide
        const slide = button.closest('.dl-page-swiper-pop-h-swiper-slide');
        if (!slide) return;

        // 获取 slide 的 block-id
        const blockId = slide.dataset.blockId;
        if (!blockId) return;

        // 先在组件内查找，如果找不到则在整个文档中查找
        let popContainer = this.querySelector(`.dl-page-swiper-pop-h-item-pop-btn-pop[data-pop-id="${blockId}"]`);
        if (!popContainer) {
          popContainer = document.querySelector(`.dl-page-swiper-pop-h-item-pop-btn-pop[data-pop-id="${blockId}"]`);
        }

        if (!popContainer) return;

        // 查找弹窗元素并打开
        const popElement = popContainer.querySelector('dl-pop-base-v2');
        if (popElement && typeof popElement.show === 'function') {
          popElement.show();
        }
      });
    });

    // 获取所有订阅按钮
    const subscribeButtons = this.querySelectorAll('dl-product-form-h');
    subscribeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        let popContainer = button.closest('dl-pop-base-v2');
        //如果成功加购，则关闭该弹窗
        const unsubscribeUpdate = window.subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
          if (payload?.source === 'product-form') {
            popContainer.hide?.();
            unsubscribeUpdate();
          }
        });

      });
    });
  }

  updatePagination() {
    if (!this.swiper || !this.currentEl) return;

    const currentIndex = this.swiper.realIndex + 1;
    this.currentEl.textContent = currentIndex;
  }

  updateButtonsState() {
    if (!this.swiper) return;

    const isBeginning = this.swiper.isBeginning;
    const isEnd = this.swiper.isEnd;

    // 更新上一张按钮状态
    if (this.prevBtn) {
      if (isBeginning) {
        this.prevBtn.classList.add('dl-disabled');
      } else {
        this.prevBtn.classList.remove('dl-disabled');
      }
    }

    // 更新下一张按钮状态
    if (this.nextBtn) {
      if (isEnd) {
        this.nextBtn.classList.add('dl-disabled');
      } else {
        this.nextBtn.classList.remove('dl-disabled');
      }
    }
  }

  // 统一所有 slide 的高度
  unifySlideHeights() {
    // 获取第一个 slide 的媒体元素
    const firstSlide = this.querySelector('.dl-page-swiper-pop-h-swiper-slide');
    if (!firstSlide) return;

    const firstMedia = firstSlide.querySelector('.dl-page-swiper-pop-h-item-media img, .dl-page-swiper-pop-h-item-media video');
    if (!firstMedia) return;

    // 如果是图片，等待加载完成
    if (firstMedia.tagName === 'IMG') {
      if (firstMedia.complete) {
        this.setAllSlidesHeight(firstMedia);
      } else {
        firstMedia.addEventListener('load', () => {
          this.setAllSlidesHeight(firstMedia);
        });
      }
    } else {
      // 如果是视频，等待 loadedmetadata 事件
      if (firstMedia.readyState >= 1) {
        this.setAllSlidesHeight(firstMedia);
      } else {
        firstMedia.addEventListener('loadedmetadata', () => {
          this.setAllSlidesHeight(firstMedia);
        });
      }
    }
  }

  // 设置所有 slide 的高度
  setAllSlidesHeight(referenceMedia) {
    // 移除动态设置高度，让 CSS 完全控制
    // 只需要在图片加载完成后更新 Swiper 即可
    if (this.swiper) {
      this.swiper.update();
    }
  }

  // 绑定窗口 resize 事件
  bindResizeEvent() {
    this.resizeTimeout = null;
    this.resizeHandler = () => {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout(() => {
        // 更新 Swiper 实例以适应新的视口尺寸
        if (this.swiper) {
          this.swiper.update();
        }
      }, 200);
    };

    window.addEventListener('resize', this.resizeHandler);
  }

  // 销毁 Swiper 实例
  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    // 移除 resize 监听
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }

    // 清除 timeout
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }

  // 公开的 API 方法
  slideTo(index) {
    if (this.swiper) {
      this.swiper.slideTo(index);
    }
  }

  slideNext() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  slidePrev() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  getCurrentIndex() {
    return this.swiper ? this.swiper.realIndex : 0;
  }

  getTotalSlides() {
    return this.swiper ? this.swiper.slides.length : 0;
  }
}

// 注册自定义元素
if (!customElements.get('dl-page-swiper-pop-h')) {
  customElements.define('dl-page-swiper-pop-h', DLPageSwiperPopH);
}

